import { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import styles from "./textarea.css";

const Textarea = ({
  value,
  placeholder,
  label,
  onChange,
  disabled,
  allowResize,
  className,
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight + 2;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [value]);

  return (
    <div
      className={`${styles.container} ${className || ""} ${
        disabled ? styles.disabled : ""
      }`}
    >
      {label && <span className={styles.label}>{label}</span>}
      <textarea
        className={`${styles.textarea} ${
          !allowResize ? styles.disableResize : ""
        }`}
        disabled={disabled}
        onChange={onChange && onChange}
        placeholder={placeholder}
        ref={textareaRef}
        value={value || ""}
      />
    </div>
  );
};

Textarea.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  allowResize: PropTypes.bool,
  className: PropTypes.string,
};

export default Textarea;
